import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import apiClient from "../services/apiClient";
import { AUTH_ENDPOINTS } from "../constants/endpoints";

export const useRegistrationStatus = (showToast = true) => {
  const [isRegistrationAllowed, setIsRegistrationAllowed] = useState(null);
  const [lastDate, setLastDate] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let mounted = true;

    const checkRegistrationAllowed = async () => {
      try {
        setIsLoading(true);
        // const response = await axios.get(checkRegistration);
        const response = await apiClient.get(AUTH_ENDPOINTS.CHECK_REGISTRATION, { isProtected: false });

        const allowed = response?.data?.data?.allowed ?? false;
        const deadline = response?.data?.data?.last_date;

        if (mounted) {
          setIsRegistrationAllowed(allowed);
          setLastDate(deadline);
          if (showToast) {
            toast.success(response.data.message || "Registration status updated");
          }
        }
      } catch (error) {
        console.error("Error checking registration status:", error);
        if (mounted) {
          setIsRegistrationAllowed(false);
          setLastDate(null);
          if (showToast) {
            toast.error(error.response?.data?.message || "Failed to check registration status");
          }
        }
      } finally {
        if (mounted) setIsLoading(false);
      }
    };

    checkRegistrationAllowed();

    // Cleanup: prevent state update in StrictMode double-mount
    return () => {
      mounted = false;
    };
  }, []); // Empty array = run once


  // Helper to format date nicely
  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    return new Date(dateString).toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };


  return {
    isRegistrationAllowed,
    lastDate,
    formattedLastDate: formatDate(lastDate),
    schemeYear: new Date(lastDate || Date.now()).getFullYear(),
    isLoading,
  };
};